import React from 'react';
import Modal from 'components/ModalPopup';
import { Button, Group, Select } from '@mantine/core';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const filterSchema = z.object({
  year: z.string().optional()
});

type FilterFormData = z.infer<typeof filterSchema>;

interface ModalFilterMasterplanProps {
  onClose: () => void;
  opened: boolean;
  onSubmitForm: (_data: { year?: number }) => void;
  defaultValues?: { year?: number };
}

const yearOptions = (() => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear - 3; i <= currentYear + 1; i++) {
    years.push({ value: i.toString(), label: i.toString() });
  }
  return years;
})();

export default function ModalFilterMasterplan({
  onClose,
  opened,
  onSubmitForm,
  defaultValues = {}
}: ModalFilterMasterplanProps) {
  const { control, handleSubmit, reset } = useForm<FilterFormData>({
    resolver: zodResolver(filterSchema),
    defaultValues: {
      year: defaultValues.year?.toString() ?? ''
    }
  });

  const handleFormSubmit = (data: FilterFormData) => {
    onSubmitForm({ year: data.year ? parseInt(data.year) : undefined });
    onClose();
  };

  const handleCancel = () => {
    reset();
    onClose();
  };

  const handleClear = () => {
    reset({ year: '' });
    onSubmitForm({ year: undefined });
    onClose();
  };

  return (
    <Modal title='Filter Data' size='md' opened={opened} close={onClose} withCloseButton>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Controller
          name='year'
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              label='Year'
              placeholder='Select year'
              data={yearOptions}
              clearable
              mb='md'
            />
          )}
        />
        <Group justify='flex-end' mt={24}>
          <Button variant='outline' onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant='default' onClick={handleClear}>
            Clear
          </Button>
          <Button type='submit'>Apply Filter</Button>
        </Group>
      </form>
    </Modal>
  );
}
